import Big from "big.js"

// NOTE: scientific notation will show up when negative exponents is less or equal -19.
Big.NE = -19
